<template>
    <div class='quota'>
       
        
        
    </div>
</template>

<script>
    export default {
        inject: ['reload'],
        data(){
            return{
            
            }
        },
        created(){
            this.getUrlKey('tid')
            this.loadData()
        },
        mounted(){
            
            
        },
        methods:{
            getUrlKey(name) {
		        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
            },
            loadData(){
                let that = this
                let params = {
                    that: this,
                    url: `${this.$config.service.ssoLogin}?tid=${that.getUrlKey('tid')}`,
                    method: "GET",
                    data:{},
                    cb(res) {
                        if (res.code == 0) {
                            let userInfo = JSON.stringify(res.resultBody)
                            window.localStorage.setItem("userInfo",userInfo);
                            window.localStorage.setItem("token",res.resultBody.token);
                            that.$router.push({path:'/'})
                            console.log('11',res)   
                        }
                        else if(res.code == 1001){
                            window.location.href= res.message
                            that.reload()
                        }
                    }
                };
                this.$util.request(params);
            }
        },
    }
</script>

<style scoped>
    
</style>